import { ErrorHandler, Injectable } from '@angular/core';
import { projectConfiguration } from '../modules/app/app.module';
import { HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { ApiService } from '../services/api.service';
import { SessionService } from '../services/session.service';
import { CustomLog } from './CustomLog';

const ignoreErrorsContaining = ['ExpressionChangedAfterItHasBeenCheckedError'];

/**
 * Custom Error Handler.
 * Required "errorHandlerEndpoint" varaible on the core configuration !
 * Send the error data on the provided endpoint
 *
 * Send the following data : {
 *  code : number
 *  message : string
 *  stak : string
 * }
 */

@Injectable({
  providedIn: 'root',
})
export class CustomErrorHandler implements ErrorHandler {
  /** The last error reported */
  lastError: CustomLog | undefined = undefined;
  core = projectConfiguration;

  constructor(
    private sessionS: SessionService,
    //private developerS: DeveloperService,
    private apiS: ApiService
  ) {}

  /** Default eror handler of angular porject */
  handleError(error: any) {
    console.error(error); // Always console log error
    var endpoint = this.core.errorHandlerEndpoint;
    var customError = new CustomLog('error', error.message, error.stack);
    //this.developerS.onError.next(customError);
    if (this.reportNedeed(customError) && endpoint != undefined) {
      this.lastError = customError;
      console.log('Reported error :' + customError.message);
      this.report(customError, true);
    }
  }

  /** Report log to backend. By default , the stack is 'Error from core-library' */
  report(customLog: CustomLog, byHandler = false) {
    if (this.core.errorHandlerEndpoint && this.sessionS.getToken()) {
      if (!byHandler) {
        customLog.stack = 'Reported manually from core-library';
      }

      try {
        fetch(this.core.errorHandlerEndpoint.url, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + this.sessionS.getToken(),
          },
          body: JSON.stringify(customLog),
        })
          .then((res) => {
            console.log('Error endpoint response : ', res);
          })
          .catch();
      } catch (e: any) {}
    }
  }

  toJira(
    pageName: string,
    pageUrl: string,
    time: string,
    req: HttpRequest<any>,
    resp: HttpErrorResponse
  ) {
    console.log('pageUrl', pageName);
    console.log('pageUrl', pageUrl);
    console.log('time', time);
    console.log('req', req);
    console.log('resp', resp);
    if (resp.url && resp.url.includes('/api/toJira')) {
      return; // No procesamos el error ya que proviene de toJira
    }
    if (resp.status === 0 && resp.statusText === 'Unknown Error') {
      return;
    }
    this.apiS.toJira(pageName, pageUrl, time, req, resp);
  }

  /** Prevent sending multiple times the same error
   * @returns If the error needs to be reported
   */
  checkLastError(error: CustomLog): boolean {
    if (this.lastError == undefined) {
      return true;
    } else {
      return !error.isTheSame(this.lastError);
    }
  }

  /** Determinates if is necessary to ignore the error
   *  @returns If the error needs to be reported
   */
  checkIgnoreErrors(error: CustomLog): boolean {
    var needReport = true;
    if (typeof error.message == 'string') {
      for (let i = 0; i < ignoreErrorsContaining.length; i++) {
        if (error.message.includes(ignoreErrorsContaining[i])) {
          needReport = false;
        }
      }
    }
    return needReport;
  }

  /** Check if the error needs to be reported / saved on the databse */
  reportNedeed(error: CustomLog) {
    return this.checkIgnoreErrors(error) && this.checkLastError(error);
  }
}
